import { WaitlistForm } from "./WaitlistForm";

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="max-w-6xl mx-auto px-6 py-16 text-center text-xs text-smoke"
    >
      <div className="max-w-md mx-auto mb-12">
        <h3 className="font-serif text-2xl text-white mb-3">
          Join the Flintly Waitlist
        </h3>
        <WaitlistForm variant="footer" />
      </div>
      <div className="flex flex-col sm:flex-row justify-between items-center border-t border-seam pt-8 gap-4">
        <div className="flex items-center gap-2 text-white font-medium">
          <span className="w-2 h-2 rounded-full bg-ember" />
          <span>Flintly</span>
        </div>
        <div>&copy; Flintly. Built for AI coding agents.</div>
        <div className="text-[11px] text-smoke">
          Recoverable Context Compression
        </div>
      </div>
    </footer>
  );
};
